export function MessageIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.66667 4.33335H10.3333M3.66667 7.00002H6.33333M7 12.3334L4.33333 9.66669H2.33333C1.59695 9.66669 1 9.06973 1 8.33335V3.00002C1 2.26364 1.59695 1.66669 2.33333 1.66669H11.6667C12.403 1.66669 13 2.26364 13 3.00002V8.33335C13 9.06973 12.403 9.66669 11.6667 9.66669H9.66667L7 12.3334Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
